import { Box, Stack } from '@mui/material';
import { Text } from '@telegram-apps/telegram-ui';
import { FC } from 'react';
import { Page } from '../../Page';
import { ThemedSkeleton } from '@focuslee/shared-mini-app';
export const GoalsConfigurePageSkeleton: FC = () => {
  return (
    <Page back insetEnabled={false}>
      <Stack alignItems="center" justifyContent="center" minHeight="var(--tg-viewport-content-safe-area-inset-top)">
        <Text style={{ textAlign: 'center' }}>Previous goals</Text>
      </Stack>
      <Stack justifyContent="center" flex={1} direction="column" spacing={2} px={2} pt={2}>
        {[1, 2, 3].map(i => (
          <Box key={i} display="flex" alignItems="center" sx={{ py: 1 }}>
            <ThemedSkeleton variant="rectangular" width={26} height={26} sx={{ borderRadius: 1 }} />
            <Box sx={{ ml: 2, flex: 1 }}>
              <ThemedSkeleton variant="text" width="60%" height={20} />
              <Stack direction="row" spacing={1} alignItems="center" justifyContent="space-between" sx={{ mt: 0.5 }}>
                <ThemedSkeleton variant="text" width={100} height={20} />
                <ThemedSkeleton variant="text" width={60} height={20} />
              </Stack>
            </Box>
          </Box>
        ))}
      </Stack>
    </Page>
  );
};

